import styled from 'styled-components';
import { media, layout } from '@prisjakt/ui-base';

export const BadgeWrapper = styled.div`
  padding-left: ${layout.measurements.spacingSmall};
`;

export const Badge = styled.div`
  display: flex;
  align-items: center;
  & + & {
    margin-left: ${layout.measurements.spacingTiny};
  }
  gap: ${layout.measurements.spacingTiny};
`;

export const MediumUp = styled.div`
  ${media.smallOnly`
      display:none;
    `}
`;
